import { Component } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  get customerName(): string {
    return this.context?.instance.customerName;
  }

  constructor(private context: ContextService) {
  }
}
